<template>
  <span>
    <b-dropdown variant="white" size="sm" @show="onShow" @hide="onHide" ref="dropdown" class="dropdown-wrapper  " v-b-tooltip.hover :title="$t('datasubject.attach-to-data')">
      <template #button-content>
        <i class="bx bx-pencil text-secondary"></i>
      </template>

      <b-dropdown-text style="width: 250px;" class="pl-2 pr-2">
        <h6 class="pt-1 mb-1 text-center">{{ $t("datasubject.attach-to-data") }}</h6>
        <input class="form-control form-control-sm" v-model="nameFilter" :placeholder="$t('common.search')" />
      </b-dropdown-text>

      <b-dropdown-text style="width: 250px;" class="p-2">
        <simplebar v-if="pagination && pagination.docs.length > 0" style="max-height:200px">
          <b-card
            v-for="item in pagination.docs"
            no-body
            class="border mb-1 hand"
            :class="selectedItemsMap[item._id] ? 'bg-soft-primary border-primary' : ''"
            :key="item._id"
            @click="select(item)"
          >
            <b-card-body class="p-1 m-0 hider">
              <b class="mb-0 font-size-11">
                <!--

                 <i class=" mdi mdi-office-building" v-b-tooltip.hover :title="$t('datasubject.organization-datasubjects')"></i>
               -->
                {{ item.name | translate }}
              </b>
            </b-card-body>
          </b-card>
        </simplebar>
        <empty v-else width="120px">
          <h6 class="text-center">
            {{ $t("datasubject.no-data") }}
          </h6>
        </empty>
      </b-dropdown-text>

      <b-dropdown-text style="width: 250px;">
        <b-row>
          <b-col>
            <b-button variant="outline-success" size="sm" block class="bg-soft-success text-dark" @click="$refs.dropdown.hide(true)">
              {{ $t("common.ok") }} ({{ Object.keys(selectedItemsMap).length }})</b-button
            >
          </b-col>
          <b-col>
            <b-button variant="outline-secondary" size="sm" block @click="$emit('openPanel')"> <i class="mdi mdi-plus"></i> {{ $t("common.new") }} </b-button>
          </b-col>
        </b-row>
      </b-dropdown-text>
    </b-dropdown>

    <span v-if="isDatasubjectsLoading">
      <i class="bx bx-hourglass bx-spin font-size-16 align-middle ml-2 mr-2"></i>
      {{ $t("common.loading") }}
    </span>
    <b-badge v-else class="bg-soft-secondary border border-secondary text-dark ml-1 p-1 pl-2 pr-2 font-size-11" v-for="i in datasubjects" :key="i._id">
      {{ i.name | translate }}
    </b-badge>
  </span>
</template>

<script>
import Simplebar from "simplebar-vue";
export default {
  props: {
    datasourceData: {
      type: Object,
    },
  },
  components: { Simplebar },
  data() {
    return {
      request: {
        options: { page: 1, limit: 100, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      selectedItemsMap: {},
      hasAnyChange: false,
      datasubjects: [],
      isDatasubjectsLoading: false,
    };
  },
  watch: {
    datasourceData: {
      immediate: true,
      async handler(v) {
        if (!v) return;
        try {
          this.isDatasubjectsLoading = true;

          const response = await this.$store.dispatch("organizationDataDatasubject/paginate", {
            options: { page: 1, limit: 100 },
            query: { data: { value: this.datasourceData._id, isObject: true } },
          });

          this.datasubjects = response.data?.docs ?? [];

          this.datasubjects.forEach((element) => {
            this.selectedItemsMap[element.datasubject._id] = element.datasubject;
          });
        } catch (error) {
        } finally {
          this.isDatasubjectsLoading = false;
          this.$forceUpdate();
        }
      },
    },
    request: {
      deep: true,
      handler() {
        this.paginate();
      },
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  computed: {
    pagination() {
      return this.$store.getters["organizationDatasubject/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDatasubject/isLoading"];
    },
  },
  mounted() {
    this.paginate();
  },
  methods: {
    async paginate() {
      await this.$store.dispatch("organizationDatasubject/paginate", this.request, false);
    },
    async select(item) {
      if (this.selectedItemsMap[item._id]) {
        const dataDatasubject = this.datasubjects.find((i) => i.datasubject._id == item._id);
        if (dataDatasubject) {
          await this.$store.dispatch("organizationDataDatasubject/delete", dataDatasubject._id);
          delete this.selectedItemsMap[item._id];
          this.datasubjects = this.datasubjects.filter((i) => i.datasubject._id != item._id);
        }
      } else {
        const response = await this.$store.dispatch("organizationDataDatasubject/save", {
          data: this.datasourceData,
          datasubject: item,
        });
        this.selectedItemsMap[item._id] = item;
        this.datasubjects.push(response.data);
      }
      this.hasAnyChange = true;

      this.$forceUpdate();
    },
    onHide() {
      if (this.hasAnyChange) {
        const values = Object.values(this.selectedItemsMap);
        this.$emit("changed", values);
      }
      this.hasAnyChange = false;
    },
    onShow() {
      this.paginate();
    },
  },
};
</script>
<style scoped>
.b-dropdown-text {
  padding: 0px 3px !important;
}
</style>

<style>
.dropdown-wrapper .dropdown-menu {
  border: 1px solid #dddddd;
}
</style>
